export type PdfComponentType = "PdfViewer" | "ScreenCard";

/**
 * The native PDF viewer must own its own scroll, and the ScreenCard holding it must NOT scroll.
 *
 * This holds on every platform. On iOS in particular, the native PDF view (PDFKit) uses the same
 * internal scroll view both to scroll the document and to pan the page once it has been pinch-zoomed.
 * Delegating the scroll to the parent ScreenCard (the previous iOS-only behavior) disabled that
 * internal scroll view, which made it impossible to pan the PDF horizontally/vertically after a zoom.
 * Letting the PDF viewer own the scroll (as on Android) keeps zoom + pan working.
 *
 * On the web the scroll behavior is never used ( iframe ).
 * @param component
 */
export const isScrollEnabledForPdfComponent = (component: PdfComponentType): boolean =>
    component === "PdfViewer";
